import { lazy } from 'react';

const LoginPage = lazy(() => import('./pages/LoginPage.jsx'));
const ForgotPasswordPage = lazy(() => import('./pages/ForgotPasswordPage.jsx'));
const ResetPasswordPage = lazy(() => import('./pages/ResetPasswordPage.jsx'));
const UsersPage = lazy(() => import('./pages/UsersPage.jsx'));
const ProfilePage = lazy(() => import('./pages/ProfilePage.jsx'));

const moduleDef = {
  name: 'auth',
  publicRoutes: [
    { path: '/login', element: LoginPage },
    { path: '/forgot-password', element: ForgotPasswordPage },
    { path: '/reset-password', element: ResetPasswordPage },
  ],
  routes: [
    { path: '/profile', element: ProfilePage, permission: 'auth.view' },
    { path: '/admin/users', element: UsersPage, permission: 'auth.users.view' },
  ],
  menu: [
    { path: '/admin/users', label: 'Utilisateurs', icon: 'People', order: 900, section: 'Administration', permission: 'auth.users.view' },
  ],
  providers: [],
};

export default moduleDef;
